import React, { useEffect, useMemo, useState } from "react";
import {
  formatDataVmailUnitelCompate,
  getDateChangeTime,
} from "../../../../helper/helper";
import { TYPE_GET_DATE } from "../../../../helper/const";
import FilterTime from "../../../components/FilterTime";
import { useSelector } from "react-redux";
import DashboardCompare from "../../components/DashboardCompare";
import { Tabs } from 'antd';
const { TabPane } = Tabs;

export default function Compare({ tabActive, handleGetData }) {
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneDayAgo)
  );
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const { result = {} } =
    useSelector((state) => state.reducerVmUnitel?.data) || {};
  const { data: vm_mytel = [] } = result;

  useEffect(() => {
    if (tabActive !== "3") return;

    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive]);

  const dataChart = useMemo(() => {
    const convertData = formatDataVmailUnitelCompate(
      vm_mytel,
      startDate,
      endDate
    );
    return convertData || [];
  }, [vm_mytel, startDate, endDate]);
  const dataChartMissCall = useMemo(() => {
    const convertData = formatDataVmailUnitelCompate(
      vm_mytel,
      startDate,
      endDate,
      true
    );
    return convertData || [];
  }, [vm_mytel, startDate, endDate]);
  const dataChartCall = useMemo(() => {
    const convertData = formatDataVmailUnitelCompate(
      vm_mytel,
      startDate,
      endDate,
      false,
      true
    );
    return convertData || [];
  }, [vm_mytel, startDate, endDate]);
  const dataChartVM = useMemo(() => {
    const convertData = formatDataVmailUnitelCompate(
      vm_mytel,
      startDate,
      endDate,
      false,
      false,
      true
    );
    return convertData || [];
  }, [vm_mytel, startDate, endDate]);
  return (
    <>
          <div
            className="position-relative d-flex justify-right mb-2"
            style={{ justifyContent: "right" }}
          >
            <FilterTime
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
            />
          </div>
     
      <Tabs defaultActiveKey="1">
        <TabPane tab="Fee" key="1">
          <div>
            <DashboardCompare
              dataChart={dataChart}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
        <TabPane tab="Total miss call" key="2">
          <div>
            <DashboardCompare
              dataChart={dataChartMissCall}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
        <TabPane tab="Total call" key="3">
          <div>
            <DashboardCompare
              dataChart={dataChartCall}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
        <TabPane tab="Total voice message" key="4">
          <div>
            <DashboardCompare
              dataChart={dataChartVM}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </TabPane>
      </Tabs>
    </>
  );
}
